import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a18d692"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.orderState.orderConfirmDialogVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderState.orderConfirmDialogVisible) = $event)),
    title: "跟进标记",
    width: "600px",
    center: "",
    "close-on-press-escape": false,
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.confirmForm,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "意向试驾车型：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.confirmForm.models,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.confirmForm.models) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carModels, (model) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      label: model.label,
                      key: model.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(model.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "预计试驾时间：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                size: "small",
                modelValue: _ctx.confirmForm.test_drive_at,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmForm.test_drive_at) = $event)),
                type: "date",
                "value-format": "YYYY-MM-DD",
                "disabled-date": _ctx.disabledDate,
                placeholder: "请选择预计试驾时间："
              }, null, 8, ["modelValue", "disabled-date"]),
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.confirmForm.date_types,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmForm.date_types) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateTypes, (type) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      label: type.value,
                      key: type.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(type.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "跟进备注：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                autosize: {minRows: 3, maxRows: 5 },
                modelValue: _ctx.confirmForm.remark,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmForm.remark) = $event)),
                maxlength: "140",
                "show-word-limit": "",
                type: "textarea"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.orderState.orderConfirmDialogVisible = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: _ctx.testDriveTraceConfirm
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}